import mutator from '@krugom/mutator';
import { TBaseTag } from '../../components/CustomTag/types';
import { isString, set } from 'lodash';
import { contextKeys } from '../../hooks/useContexts/contextKeys';
import { childrenMutationSchemas } from './childrenMutationSchemas';

export const tagMutationSchema = (tag: TBaseTag): TBaseTag => {
  const schema = mutator.schema.construct(tag, contextKeys, [/^children\.((\w+)|(\[\d\]\.))/]);
  set(tag, 'schema', schema);
  const children = childrenMutationSchemas(tag.children);
  set(tag, 'children', children);
  return tag;
};
